import React, { useCallback } from "react";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { useSnackbar } from "notistack";

export type ToastVariant = "info" | "warning" | "success" | "error" | "default";

export const useCustomToast = () => {
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();

	const showToast = useCallback(
		(
			message: string,
			variant: ToastVariant,
			_isCloseable: boolean
		) => {
			enqueueSnackbar(`${message}`, {
				variant: variant,
				anchorOrigin: { vertical: "top", horizontal: "left" },
				style: {
					marginTop: "3rem",
				},
				autoHideDuration: 3000,
				action: (snackbarKey) => (
					<IconButton
						aria-label="close"
						color="inherit"
						sx={{ p: 0.5 }}
						onClick={() => closeSnackbar(snackbarKey)}
					>
						<CloseIcon />
					</IconButton>
				),
			});
		},
		[enqueueSnackbar, closeSnackbar]
	);

	return showToast;
};
